import React from 'react';
import { useForm } from '../../hooks/useForm';
import { consent, email, required, validateCvFile } from '../../utils/validation';
import { industries } from '../../data/industries';
import { FormField } from '../ui/FormField';
import { ConsentCheckbox } from '../ui/ConsentCheckbox';
import { FormStatus } from '../ui/FormStatus';
import { Button } from '../ui/Button';
import { CvUpload } from './CvUpload';
const levels = ['Board / Non-Executive', 'C-Suite', 'Executive / Director', 'Senior Management', 'Specialist Professional'];
const confidentiality = ['Strictly confidential — contact me before any introduction', 'Open to discreet approaches for relevant roles'];
export function CandidateRegistrationForm() {
  const {
    values,
    errors,
    status,
    setField,
    setFieldError,
    handleSubmit,
    reset
  } = useForm({
    name: '',
    email: '',
    phone: '',
    title: '',
    level: '',
    industry: '',
    location: '',
    confidentiality: confidentiality[0],
    cv: '',
    consent: false
  }, {
    name: required('Full name'),
    email: email(),
    title: required('Current title'),
    level: required('Career level'),
    consent
  });
  return <form noValidate onSubmit={handleSubmit} className="space-y-5" aria-label="Confidential candidate registration" data-id="element-79" data-mp="2k7croujqb4r7">
      <div className="grid gap-5 sm:grid-cols-2" data-id="element-80" data-mp="2p0fqpi79z6es">
        <FormField name="name" label="Full name" required autoComplete="name" value={values.name} error={errors.name} onChange={v => setField('name', v)} data-id="element-81" data-mp="2txy019p7fnnb" />
        <FormField name="email" label="Personal email" type="email" required autoComplete="email" hint="We recommend a personal rather than work address." value={values.email} error={errors.email} onChange={v => setField('email', v)} data-id="element-82" data-mp="1wca2glh0iza7" />
        <FormField name="phone" label="Phone" type="tel" autoComplete="tel" value={values.phone} onChange={v => setField('phone', v)} data-id="element-83" data-mp="2aa8brcgh85iu" />
        <FormField name="title" label="Current title" required autoComplete="organization-title" value={values.title} error={errors.title} onChange={v => setField('title', v)} data-id="element-84" data-mp="3hmqq4pj5b1a0" />
        <FormField name="level" label="Career level" type="select" required options={levels} value={values.level} error={errors.level} onChange={v => setField('level', v)} data-id="element-85" data-mp="1mk3yfpqwb56q" />
        <FormField name="industry" label="Primary industry" type="select" options={industries.map(i => i.name)} value={values.industry} onChange={v => setField('industry', v)} data-id="element-86" data-mp="1vlbl1ak1uhkz" />
        <FormField name="location" label="Preferred location(s)" className="sm:col-span-2" value={values.location} onChange={v => setField('location', v)} data-id="element-87" data-mp="1qk4ipr0oealp" />
        <FormField name="confidentiality" label="Confidentiality preference" type="select" className="sm:col-span-2" options={confidentiality} value={values.confidentiality} onChange={v => setField('confidentiality', v)} data-id="element-88" data-mp="yw2pwgtpvorb" />
      </div>
      <CvUpload required={false} fileName={values.cv} error={errors.cv} onSelect={file => {
      const problem = validateCvFile(file);
      if (problem) {
        setField('cv', '');
        setFieldError('cv', problem);
      } else setField('cv', file.name);
    }} onClear={() => setField('cv', '')} data-id="element-89" data-mp="k4kbuokf44al" />
      <ConsentCheckbox checked={values.consent} error={errors.consent} onChange={v => setField('consent', v)} data-id="element-90" data-mp="2hus4av4hyqz4">
        I have read the candidate data privacy notice. I understand Corventa will not share my details with any organisation without my permission.
      </ConsentCheckbox>
      <FormStatus status={status} onReset={reset} data-id="element-91" data-mp="3ek9ki413vvf2" />
      <Button type="submit" size="lg" variant="navy" arrow data-id="element-92" data-mp="3ehvq7xe92n8k">
        Register confidentially
      </Button>
    </form>;
}